<template>
  <div>
    <form class="form-box">
      <b-container class="container-box">
        <b-row class="no-gutters">
          <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
            <h1 class="mr-sm-4 header-main text-uppercase">โปรโมชัน</h1>
          </b-col>
          <b-col xl="8" class="text-right d-flex justify-content-end">
            <div class="d-flex text-left">
              <!-- <b-dropdown
                id="dropdown-product"
                text="ตัวเลือกเพิ่มเติม"
                class="ml-2 dropdown-option"
              >
                <b-dropdown-item @click="$router.push('/product/details/0')"
                  >นำเข้าข้อมูล</b-dropdown-item
                >
                <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
                <b-dropdown-item>ดาวน์โหลดไฟล์ต้นฉบับ</b-dropdown-item>
              </b-dropdown> -->
              <router-link to="/promotion/details/0">
                <b-button class="purple-btn ml-2">
                  <font-awesome-icon
                    icon="plus-circle"
                    title="create-btn"
                    class="white-color mr-0 mr-sm-1"
                  />
                  <span class="d-none d-sm-inline">สร้างใหม่ </span>
                </b-button>
              </router-link>
            </div>
          </b-col>
        </b-row>
        <div class="mt-4 p-4 bg-white bg-border-top">
          <h3 class="text-uppercase">โปรโมชันเปิดใช้งาน</h3>
          <b-table-simple
            responsive
            striped
            class="mt-4 table-list"
            :busy="isBusy"
          >
            <b-thead class="active-header">
              <b-tr>
                <template v-for="header in fields">
                  <b-th
                    :key="`header-${header.key}`"
                    colspan="1"
                    :style="{
                      width:
                        header.key === 'name'
                          ? '300px'
                          : header.key === 'sortOrder'
                          ? '100px'
                          : header.key === 'validDate'
                          ? '250px'
                          : header.key === 'salesChannel'
                          ? '200px'
                          : header.key === 'enabled'
                          ? '70px'
                          : 'auto',
                      'white-space': 'nowrap',
                    }"
                  >
                    <div
                      :style="{
                        'min-height': '30px',
                        'padding-top': '4px',
                        'padding-bottom': '4px',
                      }"
                    >
                      {{ header.label }}
                    </div>
                  </b-th>
                </template>
              </b-tr>
            </b-thead>
            <draggable
              v-model="draggableActive.list"
              tag="b-tbody"
              @start="draggableActive.drag = true"
              @end="draggableActive.drag = false"
              :options="draggableOption"
              group="promotionList"
              handle=".handle"
            >
              <template v-for="item in draggableActive.list">
                <b-tr :key="item.id" class="border-bottom">
                  <template v-for="(header, headerIndex) in fields">
                    <b-td :key="`${item.id}-${headerIndex}`">
                      <template v-if="header.key == 'sortOrder'">
                        <div class="align-middle handle">
                          <b-icon icon="chevron-up" aria-hidden="true"></b-icon
                          ><br />
                          <b-icon
                            icon="chevron-down"
                            aria-hidden="true"
                          ></b-icon>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'enabled'">
                        <b-form-checkbox
                          v-model="item.enabled"
                          class="switch-enabled"
                          name="check-button"
                          size="lg"
                          @change="changeEabled(item)"
                          switch
                        >
                        </b-form-checkbox>
                      </template>
                      <template v-else-if="header.key == 'name'">
                        <div class="text-left">
                          <span>
                            {{ item.name }}
                          </span>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'validDate'">
                        <span
                          >{{ new Date(item.startDate) | moment($formatDate) }}
                          -
                        </span>
                        <span>{{
                          new Date(item.endDate) | moment($formatDate)
                        }}</span>
                      </template>
                      <template v-else-if="header.key == 'salesChannel'">
                        <div>
                          <div v-if="item.logos.length > 0">
                            <b-img
                              v-for="(image, index) in item.logos"
                              :key="index"
                              fluid
                              :src="image.iconUrl"
                              class="picture-shipping ml-2"
                              alt="Image 1"
                              ><span v-if="!image.iconUrl">{{
                                image.salesChannelName
                              }}</span></b-img
                            >
                          </div>
                          <div v-else>-</div>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'ids'">
                        <div class="d-flex justify-content-center">
                          <router-link
                            :to="{
                              path: '/promotion/details/' + item.id,
                            }"
                          >
                            <b-button
                              variant="link"
                              class="text-warning px-1 py-0"
                            >
                              <font-awesome-icon
                                icon="pencil-alt"
                                title="Edit"
                              />
                            </b-button>
                          </router-link>
                          <b-button
                            variant="link"
                            class="text-danger px-1 py-0"
                            @click="deleteData(item.id)"
                          >
                            <font-awesome-icon
                              icon="trash-alt"
                              title="Delete"
                            />
                          </b-button>
                        </div>
                      </template>
                      <template v-else>
                        {{ item[header.key] }}
                      </template>
                    </b-td>
                  </template>
                </b-tr>
              </template>
            </draggable>
            <b-tr
              v-if="draggableActive.list.length <= 0 && checkItemTableActive"
              class="border-bottom bg-gray"
            >
              <template v-for="(header, headerIndex) in fields">
                <b-td :key="`${headerIndex}`">
                  <template v-if="header.key == 'validDate'">
                    <div class="text-left ml-2">
                      <b-spinner variant="dark"></b-spinner>
                    </div>
                  </template> </b-td></template
            ></b-tr>
            <b-tr
              v-if="draggableActive.list.length <= 0 && !checkItemTableActive"
              class="border-bottom bg-gray"
            >
              <template v-if="isBusy">
                <b-td colspan="7">
                  <div class="text-center text-black-50 my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </b-td>
              </template>
              <template v-else v-for="(header, headerIndex) in fields">
                <b-td :key="`${headerIndex}`">
                  <template v-if="header.key == 'validDate'">
                    <div class="text-left ml-2">
                      <span class="text-gray">ไม่พบข้อมูล</span>
                    </div>
                  </template>
                </b-td></template
              >
            </b-tr>
          </b-table-simple>
          <b-row class="px-3 pb-3" v-if="!isBusy">
            <b-col class="form-inline justify-content-end">
              <div class="d-sm-flex mr-3">
                <b-pagination
                  v-model="tableFilterActive.pageNo"
                  :total-rows="tableFilterActive.rows"
                  :per-page="tableFilterActive.perPage"
                  class="m-md-0 page-item"
                  @change="paginationActive"
                ></b-pagination>
              </div>
              <b-form-select
                v-model="tableFilterActive.perPage"
                @change="hanndleChangePerpageActive"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
              <h3 class="text-uppercase">
                โปรโมชันปิดใช้งาน
                <span class="text-danger sub-header"
                  >(สามารถสลับสถานะระหว่างใช้งาน และไม่ใช้งานได้)</span
                >
              </h3>
            </b-col>
            <b-col xl="6" class="text-right d-flex justify-content-end">
              <div class="d-flex text-left">
                <b-input-group class="panel-input-serach">
                  <b-form-input
                    id="product-search"
                    class="input-serach"
                    placeholder="ค้นหาด้วยชื่อโปรโมชัน"
                    v-model="tableFilterInactive.search"
                    v-on:keyup.13="submitFilter"
                    @blur="submitFilter"
                  ></b-form-input>
                  <b-input-group-prepend @click="submitFilter">
                    <span class="icon-input m-auto pr-2">
                      <font-awesome-icon icon="search" title="View" />
                    </span>
                  </b-input-group-prepend>
                </b-input-group>
                <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
                  <font-awesome-icon
                    icon="filter"
                    title="filter-btn"
                    class="main-color mr-0 mr-sm-1"
                  />
                  <span class="d-none d-sm-inline">ตัวกรอง </span>
                </b-button>
                <b-sidebar
                  id="sidebar-filter"
                  v-model="sidebarShow"
                  backdrop
                  shadow
                  backdrop-variant="dark"
                  right
                  ref="filterSidebar"
                  aria-labelledby="sidebar-filter-title"
                  no-header
                >
                  <template #default="{ hide }">
                    <div
                      class="
                        p-3
                        sidebar-filter-header
                        d-flex
                        justify-content-between
                      "
                    >
                      <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
                      <font-awesome-icon
                        class="my-auto"
                        icon="times-circle"
                        color="#FFFFFF"
                        @click="hide"
                      />
                    </div>
                    <div class="px-3 py-2">
                      <div class="mt-2">
                        <b-input-group class="panel-input-serach">
                          <b-form-input
                            id="product-search"
                            class="input-serach"
                            placeholder="ค้นหาด้วยชื่อโปรโมชัน"
                            v-model="tableFilterInactive.search"
                            v-on:keyup.13="submitFilter"
                            @blur="submitFilter"
                          ></b-form-input>
                          <b-input-group-prepend @click="submitFilter">
                            <span class="icon-input m-auto pr-2">
                              <font-awesome-icon icon="search" title="View" />
                            </span>
                          </b-input-group-prepend>
                        </b-input-group>
                      </div>
                      <div class="mt-3">
                        <div class="font-weight-bold mb-2">
                          ช่วงเวลาโปรโมชัน
                        </div>
                        <div class="ml-1 mt-2">
                          <div class="font-weight-bold">วันที่เริ่มต้น</div>
                          <div class="input-container">
                            <datetime
                              type="datetime"
                              :input-style="styleDatetime"
                              v-model="tableFilterInactive.validFrom"
                              placeholder="DD/MM/YYYY (HH:MM)"
                              format="dd/MM/yyyy (HH:mm)"
                              value-zone="Asia/Bangkok"
                              @close="changeStartDate"
                              ref="transferDateStart"
                            >
                            </datetime>
                            <div
                              class="icon-container text-right"
                              @click="$refs.transferDateStart.isOpen = true"
                            >
                              <font-awesome-icon
                                icon="calendar-alt"
                                class="pointer"
                                color="#B41BB4"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="ml-1 mt-2">
                          <div class="font-weight-bold">วันที่สิ้นสุด</div>
                          <div class="input-container">
                            <datetime
                              type="datetime"
                              :input-style="styleDatetime"
                              v-model="tableFilterInactive.validTo"
                              placeholder="DD/MM/YYYY (HH:MM)"
                              format="dd/MM/yyyy (HH:mm)"
                              value-zone="Asia/Bangkok"
                              ref="transferDateEnd"
                              :min-datetime="tableFilterInactive.validFrom"
                              @close="onChangeEndDate"
                            >
                            </datetime>
                            <div
                              class="icon-container text-right"
                              @click="$refs.transferDateEnd.isOpen = true"
                            >
                              <font-awesome-icon
                                icon="calendar-alt"
                                class="pointer"
                                color="#B41BB4"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #footer>
                    <div
                      class="
                        d-flex
                        justify-content-between
                        shadow
                        align-items-center
                        border-top
                      "
                    >
                      <div class="w-100">
                        <b-button
                          block
                          size="lg"
                          variant="light"
                          class="
                            text-dark
                            w-100
                            border-radius-0
                            btn-clear-filter
                          "
                          @click="clearFilter"
                          >ล้างตัวกรอง</b-button
                        >
                      </div>
                      <div class="w-100">
                        <b-button
                          v-b-toggle.sidebar-filter
                          @click="submitFilter"
                          block
                          size="lg"
                          variant="light"
                          class="text-body btn-main w-100 border-radius-0"
                        >
                          ยืนยัน
                        </b-button>
                      </div>
                    </div>
                  </template>
                </b-sidebar>
              </div>
            </b-col>
          </b-row>
          <b-table-simple
            responsive
            striped
            class="mt-4 table-list"
            :busy="isBusy"
          >
            <b-thead class="active-header">
              <b-tr>
                <template v-for="header in fields">
                  <b-th
                    :key="`header-${header.key}`"
                    colspan="1"
                    :style="{
                      width:
                        header.key === 'name'
                          ? '300px'
                          : header.key === 'sortOrder'
                          ? '100px'
                          : header.key === 'validDate'
                          ? '250px'
                          : header.key === 'salesChannel'
                          ? '200px'
                          : header.key === 'enabled'
                          ? '70px'
                          : 'auto',
                      'white-space': 'nowrap',
                    }"
                  >
                    <div
                      :style="{
                        'min-height': '30px',
                        'padding-top': '4px',
                        'padding-bottom': '4px',
                      }"
                    >
                      {{ header.label }}
                    </div>
                  </b-th>
                </template>
              </b-tr>
            </b-thead>
            <draggable
              v-model="draggableInactive.list"
              tag="b-tbody"
              @start="draggableInactive.drag = true"
              @end="draggableInactive.drag = false"
              :options="draggableOption"
              group="promotionList"
              handle=".handle"
            >
              <template v-for="item in draggableInactive.list">
                <b-tr :key="item.id" class="border-bottom">
                  <template v-for="(header, headerIndex) in fields">
                    <b-td :key="`${item.id}-${headerIndex}`">
                      <template v-if="header.key == 'sortOrder'">
                        <div class="align-middle handle">
                          <b-icon icon="chevron-up" aria-hidden="true"></b-icon
                          ><br />
                          <b-icon
                            icon="chevron-down"
                            aria-hidden="true"
                          ></b-icon>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'enabled'">
                        <b-form-checkbox
                          v-model="item.enabled"
                          class="switch-enabled"
                          name="check-button"
                          size="lg"
                          @change="changeEabled(item)"
                          switch
                        >
                        </b-form-checkbox>
                      </template>
                      <template v-else-if="header.key == 'name'">
                        <div class="text-left">
                          <span>
                            {{ item.name }}
                          </span>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'validDate'">
                        <span
                          >{{ new Date(item.startDate) | moment($formatDate) }}
                          -
                        </span>
                        <span>{{
                          new Date(item.endDate) | moment($formatDate)
                        }}</span>
                      </template>
                      <template v-else-if="header.key == 'salesChannel'">
                        <div>
                          <div v-if="item.logos.length > 0">
                            <b-img
                              v-for="(image, index) in item.logos"
                              :key="index"
                              fluid
                              :src="image.iconUrl"
                              class="picture-shipping ml-2"
                              alt="Image 1"
                              ><span v-if="!image.iconUrl">{{
                                image.salesChannelName
                              }}</span></b-img
                            >
                          </div>
                          <div v-else>-</div>
                        </div>
                      </template>
                      <template v-else-if="header.key == 'ids'">
                        <div class="d-flex justify-content-center">
                          <router-link
                            :to="{
                              path: '/promotion/details/' + item.id,
                            }"
                          >
                            <b-button
                              variant="link"
                              class="text-warning px-1 py-0"
                            >
                              <font-awesome-icon
                                icon="pencil-alt"
                                title="Edit"
                              />
                            </b-button>
                          </router-link>
                          <b-button
                            variant="link"
                            class="text-danger px-1 py-0"
                            @click="deleteData(item.id)"
                          >
                            <font-awesome-icon
                              icon="trash-alt"
                              title="Delete"
                            />
                          </b-button>
                        </div>
                      </template>
                      <template v-else>
                        {{ item[header.key] }}
                      </template>
                    </b-td>
                  </template>
                </b-tr>
              </template>
            </draggable>
            <b-tr
              v-if="
                draggableInactive.list.length <= 0 && checkItemTableInactive
              "
              class="border-bottom bg-gray"
            >
              <template v-for="(header, headerIndex) in fields">
                <b-td :key="`${headerIndex}`">
                  <template v-if="header.key == 'validDate'">
                    <div class="text-left ml-2">
                      <b-spinner variant="dark"></b-spinner>
                    </div>
                  </template> </b-td></template
            ></b-tr>
            <b-tr
              v-if="
                draggableInactive.list.length <= 0 && !checkItemTableInactive
              "
              class="border-bottom bg-gray"
            >
              <template v-if="isBusy">
                <b-td colspan="7">
                  <div class="text-center text-black-50 my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </b-td>
              </template>
              <template v-else v-for="(header, headerIndex) in fields">
                <b-td :key="`${headerIndex}`">
                  <template v-if="header.key == 'validDate'">
                    <div class="text-left ml-2">
                      <span class="text-gray">ไม่พบข้อมูล</span>
                    </div>
                  </template>
                </b-td></template
              >
            </b-tr>
          </b-table-simple>
          <b-row class="px-3 pb-3" v-if="!isBusy">
            <b-col class="form-inline justify-content-end">
              <div class="d-sm-flex mr-3">
                <b-pagination
                  v-model="tableFilterInactive.pageNo"
                  :total-rows="tableFilterInactive.rows"
                  :per-page="tableFilterInactive.perPage"
                  class="m-md-0 page-item"
                  @change="paginationInactive"
                ></b-pagination>
              </div>
              <b-form-select
                v-model="tableFilterInactive.perPage"
                @change="hanndleChangePerpageInactive"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </form>
    <ModalAlertConfirm
      msg="ยืนยันการลบ"
      text="คุณแน่ใจหรือไม่ว่าต้องการลบ"
      btnConfirm="ลบ"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
// https://bootstrap-vue.org/docs/components/table#simple-tables
import draggable from "vuedraggable";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import * as moment from "moment/moment";

function promiseForEach(arr, cb) {
  var i = 0;

  var nextPromise = function () {
    if (i >= arr.length) {
      // Processing finished.
      return;
    }

    // Process next function. Wrap in `Promise.resolve` in case
    // the function does not return a promise
    var newPromise = Promise.resolve(cb(arr[i], i));
    i++;
    // Chain to finish processing.
    return newPromise.then(nextPromise);
  };

  // Kick off the chain.
  return Promise.resolve().then(nextPromise);
}

export default {
  name: "StoreTypeIndex",
  data() {
    return {
      fields: [
        {
          key: "sortOrder",
          label: "ลำดับ",
        },
        {
          key: "enabled",
          label: "ใช้งาน",
        },
        {
          key: "name",
          label: "ชื่อโปรโมชัน",
        },
        {
          key: "validDate",
          label: "Valid From-To",
        },
        {
          key: "promotionTypeName",
          label: "Type",
        },
        {
          key: "salesChannel",
          label: "Channel",
        },
        {
          key: "ids",
          label: "Action",
        },
      ],
      fieldsInactive: [
        {
          key: "enabled",
          label: "ใช้งาน",
        },
        {
          key: "name",
          label: "ชื่อโปรโมชัน",
        },
        {
          key: "validDate",
          label: "Valid From-To",
        },
        {
          key: "promotionTypeName",
          label: "Type",
        },
        {
          key: "salesChannel",
          label: "Channel",
        },
        {
          key: "ids",
          label: "Action",
        },
      ],
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      sidebarShow: false,
      deleteID: null,
      isBusy: true,
      tableFilterActive: {
        perPage: 10,
        pageNo: 1,
        sortByOrderOrId: 0,
        search: "",
        status: [1],
        rows: 0,
        validFrom: null,
        validTo: null,
      },
      tableFilterInactive: {
        perPage: 10,
        pageNo: 1,
        sortByOrderOrId: 0,
        search: "",
        status: [0],
        rows: 0,
        validFrom: null,
        validTo: null,
      },
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      checkAll: false,
      selectAllCb: false,
      cbHighlight: false,
      selected: 0,
      draggableOption: {
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        animation: 200,
      },
      draggableActive: {
        drag: true,
        list: [],
        newList: [],
      },
      draggableInactive: {
        drag: true,
        list: [],
      },
      countListActive: 0,
      countListInActive: 0,
      checkItemTableActive: false,
      checkItemTableInactive: false,
    };
  },
  components: {
    draggable,
    ModalAlertConfirm,
  },
  watch: {
    "draggableActive.list": {
      handler(val) {
        var sumSort =
          (this.tableFilterActive.pageNo - 1) * this.tableFilterActive.perPage;
        this.draggableActive.newList = [...this.draggableActive.list];
        promiseForEach(this.draggableActive.list, (element, index) => {
          this.draggableActive.newList[index].sortOrder = index + 1 + sumSort;
          this.draggableActive.newList[index].enabled = true;
        }).then(() => {
          var body = {
            promotion: this.draggableActive.newList.map((x) => {
              return JSON.parse(
                JSON.stringify({
                  id: x.id,
                  sortOrder: x.sortOrder,
                  enabled: x.enabled,
                })
              );
            }),
          };
          this.checkItemTableActive = this.draggableActive.newList.length == 0 ? false : true;
          this.axios
            .post(`${this.$baseUrl}/promotion/SortOrder/Save`, body)
            .then((res) => {
              if (res.result) {
                if (
                  this.countListActive >= this.tableFilterActive.perPage ||
                  this.countListInActive >= this.tableFilterInactive.perPage ||
                  (this.countListActive < this.tableFilterActive.perPage &&
                    this.countListActive != 0) ||
                  (this.countListInActive < this.tableFilterInactive.perPage &&
                    this.countListInActive != 0)
                ) {
                  if (
                    this.draggableActive.newList.length !=
                      this.tableFilterActive.perPage ||
                    this.draggableInactive.newList.length !=
                      this.tableFilterInactive.perPage
                  ) {
                    this.countListActive = 0;
                    this.countListInActive = 0;
                    this.getList();
                  }
                }
              }
            });
        });
      },
    },
    "draggableInactive.list": {
      handler(val) {
        var sumSort =
          (this.tableFilterInactive.pageNo - 1) *
          this.tableFilterInactive.perPage;
        this.draggableInactive.newList = [...this.draggableInactive.list];
        promiseForEach(this.draggableInactive.list, (element, index) => {
          this.draggableInactive.newList[index].sortOrder = index + 1 + sumSort;
          this.draggableInactive.newList[index].enabled = false;
        }).then(() => {
          var body = {
            promotion: this.draggableInactive.newList.map((x) => {
              return JSON.parse(
                JSON.stringify({
                  id: x.id,
                  sortOrder: x.sortOrder,
                  enabled: x.enabled,
                })
              );
            }),
          };
          this.checkItemTableInactive = this.draggableInactive.newList.length == 0 ? false : true;
          this.axios
            .post(`${this.$baseUrl}/promotion/SortOrder/Save`, body)
            .then((res) => {
              if (res.result) {
                //
              }
            });
        });
      },
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  created: async function () {
    await this.getFilter();
    await this.getList();
  },
  methods: {
    getFilter() {
      if (this.$route.query.activeSearch)
        this.tableFilterActive.search = this.$route.query.activeSearch;
      if (this.$route.query.activePageNo)
        this.tableFilterActive.pageNo =
          parseInt(this.$route.query.activePageNo) || 1;
      if (this.$route.query.activePerPage)
        this.tableFilterActive.perPage =
          parseInt(this.$route.query.activePerPage) || 10;
      if (this.$route.query.inActivePageNo)
        this.tableFilterInactive.pageNo =
          parseInt(this.$route.query.inActivePageNo) || 1;
      if (this.$route.query.inActivePerPage)
        this.tableFilterInactive.perPage =
          parseInt(this.$route.query.inActivePerPage) || 10;
      if (this.$route.query.inActiveFrom)
        this.tableFilterInactive.validFrom = this.$route.query.inActiveFrom;
      if (this.$route.query.inActiveTo)
        this.tableFilterInactive.validTo = this.$route.query.inActiveTo;
      if (this.$route.query.inActiveSearch)
        this.tableFilterInactive.search = this.$route.query.inActiveSearch;
    },
    setFilter() {
      this.$router
        .push({
          path: "/promotion",
          query: {
            brandID: this.$route.query.brandID,
            activeSearch: this.tableFilterActive.search,
            activePageNo: this.tableFilterActive.pageNo,
            activePerPage: this.tableFilterActive.perPage,

            inActiveSearch: this.tableFilterInactive.search,
            inActivePageNo: this.tableFilterInactive.pageNo,
            inActivePerPage: this.tableFilterInactive.perPage,
            inActiveFrom: this.tableFilterInactive.validFrom || "",
            inActiveTo: this.tableFilterInactive.validTo || "",
          },
        })
        .catch((err) => {});
    },
    getList: async function (flag) {
      var filter;
      if (flag == null) {
        await this.getList(0);
        await this.getList(1);
        return;
      } else if (flag == 1) {
        filter = { ...this.tableFilterActive };
      } else if (flag == 0) {
        filter = { ...this.tableFilterInactive };
      }
      let pageNo = filter.pageNo;

      this.isBusy = true;
      this.draggableActive.list = [];
      await this.axios
        .post(`${this.$baseUrl}/promotion/list`, filter)
        .then((data) => {
          if (data.result == 1) {
            if (flag == 1) {
              this.checkItemTableActive =
                data.detail.dataList.length > 0 ? true : false;
              this.draggableActive.list = data.detail.dataList;
              this.tableFilterActive.rows = data.detail.count;
              setTimeout(() => {
                this.countListActive = data.detail.count;
              }, 2000);
            } else if (flag == 0) {
              this.checkItemTableInactive =
                data.detail.dataList.length > 0 ? true : false;
              this.draggableInactive.list = data.detail.dataList;
              this.tableFilterInactive.rows = data.detail.count;
              setTimeout(() => {
                this.countListInActive = data.detail.count;
              }, 2000);
            }
          }
          this.isBusy = false;
        });
      if (flag == 1) {
        this.tableFilterActive.pageNo = pageNo;
      } else if (flag == 0) {
        this.tableFilterInactive.pageNo = pageNo;
      }
    },
    clearFilter: async function () {
      this.tableFilterInactive = {
        perPage: 10,
        pageNo: 1,
        sortByOrderOrId: 0,
        search: "",
        status: [0],
        rows: 0,
        validFrom: null,
        validTo: null,
      };
      await this.setFilter();
      this.getList();
      this.sidebarShow = false;
    },
    changeEabled(item) {
      if (item.enabled) {
        var sumSort =
          (this.tableFilterActive.pageNo - 1) * this.tableFilterActive.perPage;
        this.draggableActive.list.splice(item.sortOrder - sumSort - 1, 1);
        this.draggableInactive.list.unshift(item);
      } else {
        var sumSort =
          (this.tableFilterInactive.pageNo - 1) *
          this.tableFilterInactive.perPage;
        this.draggableInactive.list.splice(item.sortOrder - sumSort - 1, 1);
        this.draggableActive.list.unshift(item);
      }
    },
    paginationActive(page) {
      this.tableFilterActive.pageNo = page;
      this.setFilter();
      this.getList();
    },
    paginationInactive(page) {
      this.tableFilterInactive.pageNo = page;
      this.setFilter();
      this.getList();
    },
    hanndleChangePerpageActive(value) {
      this.tableFilterActive.pageNo = 1;
      this.tableFilterActive.perPage = value;
      this.setFilter();
      this.getList();
    },
    hanndleChangePerpageInactive(value) {
      this.tableFilterInactive.pageNo = 1;
      this.tableFilterInactive.perPage = value;
      this.setFilter();
      this.getList();
    },
    deleteData: async function (id) {
      this.deleteID = id;
      this.$refs.isModalAlertConfirm.show();
    },
    confirmDelete() {
      this.axios
        .delete(`${this.$baseUrl}/promotion/remove/${this.deleteID}`)
        .then((data) => {
          this.getList();
        });
      this.$refs.isModalAlertConfirm.hide();
    },
    checkAllSelect() {
      if (this.selectAllCb) {
        this.tableFilter_Inactive.status = [];
      } else {
        this.tableFilter_Inactive.status = [1, 0];
      }
    },
    submitFilter() {
      this.tableFilterInactive.pageNo = 1;
      this.tableFilterInactive.perPage = 10;
      this.setFilter();
      this.getList();
    },
    changeStartDate() {
      if (!this.tableFilterInactive.validTo) {
        this.tableFilterInactive.validTo = this.tableFilterInactive.validFrom;
      }
      if (
        this.tableFilterInactive.validFrom >= this.tableFilterInactive.validTo
      ) {
        this.tableFilterInactive.validTo = moment(
          this.tableFilterInactive.validFrom
        )
          .add("day", 1)
          .format();
      }
    },
    onChangeEndDate() {
      if (!this.tableFilterInactive.validFrom) {
        this.tableFilterInactive.validFrom = this.tableFilterInactive.validTo;
      }
    },
  },
};
</script>

<style>
.sortable-ghost {
  opacity: 1;
  background: #0011ff;
}
.sortable-chosen {
  background: #87f7ff !important;
}
.sortable-drag {
  opacity: 0.5;
  background: #969696;
}

.active-header {
  background: rgb(197, 248, 190);
}

.inactive-header {
  background: rgb(255, 196, 196);
}
.handle:hover {
  cursor: -webkit-grab;
  cursor: grab;
}
.handle:active {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.icon-drag {
  font-size: 20px;
}
.switch-enabled {
  color: #27bda8;
}
.picture-shipping {
  height: 40px;
}
::v-deep .btn-select {
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
.bg-border-top {
  border-top: 5px solid #8a44c3;
}
.sub-header {
  font-size: 14px !important;
}
</style>
